import * as React from 'react';
import type { RouteObject } from 'react-router-dom';

import { paths } from '@/paths';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import { ReservationsPage } from '@/pages/v2/reservations';
import { MyReservationDetailPage } from '@/pages/v2/reservations/reservation';

export const route: RouteObject = {
  path: paths.reservations.index,
  children: [
    {
      index: true,
      element: (
        <DashboardLayout>
          <ReservationsPage />
        </DashboardLayout>
      ),
    },
    {
      path: ':reservationId',
      element: (
        <DashboardLayout>
          <MyReservationDetailPage />
        </DashboardLayout>
      ),
    },
  ],
};





